import { useTranslation } from 'react-i18next'
import React from 'react'

import { useProcessesListById } from '../_load/ProcessesListById'
import { Col } from '../../../packages/kiti/components/structure/Grid'
import { Absolute } from '../../../packages/kiti/components/helpers/Position'
import Loading from '../../../packages/kiti/components/helpers/Loading'

const PageContent = () => {
  const { t } = useTranslation('processes')
  const [isLoading, setIsLoading] = React.useState(true)
  const { data } = useProcessesListById()

  return (
    <Col justify="center" align="center" height="100%">
      {isLoading && (
        <Absolute>
          <Loading />
        </Absolute>
      )}
      <iframe
        src={data?.configuration?.embedLink}
        title={t('processes.dashboard')}
        width="100%"
        height="100%"
        onLoad={() => setIsLoading(false)}
        style={{ border: 'none' }}
      />
    </Col>
  )
}

export default PageContent
